import React, { FunctionComponent } from 'react';

import { ReactComponent as CloseIcon } from '../../assets/icons/icon_plus.svg';
import {ClassBuilder} from 'b302-frontend-library';

interface Props {
    onClick: () => void;
    className?: string;

    grey?: boolean;
}

const CloseButton: FunctionComponent<Props> = ({ onClick, className, grey }) => {

    const getClassName = () => {
        return ClassBuilder.createClass('close-button')
            .addIf(className, className)
            .addIf('close-button--grey', grey)
            .build();
    };

    return (
        <div className={getClassName()} onClick={onClick}>
            <CloseIcon className={'close-button__icon'} />
        </div>
    );
};

export default CloseButton;
